import { createContext } from "react";

import { ISocketContext } from "../types/context/ISocketContext";

const defaultContext: ISocketContext = {
  socket: undefined,
  loading: true,
  setLoading: () => {
    //
  },
};

export const SocketContext = createContext<ISocketContext>(defaultContext);
